import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTheme } from "@mui/material/styles";
import PoolCard from "./PoolCard";
import { ctaTextSx } from "./resultatsTheme";
import type { PlayerDirectory, Pool } from "./types";

interface PoolDetailViewProps {
  pool: Pool;
  pools: Pool[];
  players: PlayerDirectory;
  highlightedLicence?: string | null;
  onSelectLicence?: (licence: string) => void;
  onBack: () => void;
  onSelectPool: (poolId: string) => void;
}

export default function PoolDetailView({
  pool,
  pools,
  players,
  highlightedLicence = null,
  onSelectLicence,
  onBack,
  onSelectPool,
}: PoolDetailViewProps): React.ReactElement {
  const theme = useTheme();
  const index = pools.findIndex((p) => p.id === pool.id);
  const prev = index > 0 ? pools[index - 1] : null;
  const next =
    index >= 0 && index < pools.length - 1 ? pools[index + 1] : null;

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          size="small"
          color="inherit"
          sx={ctaTextSx(theme)}
        >
          Toutes les poules
        </Button>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 700, fontVariantNumeric: "tabular-nums" }}
        >
          {index >= 0 ? `${index + 1} / ${pools.length}` : ""}
        </Typography>
      </Box>

      <PoolCard
        pool={pool}
        players={players}
        highlightedLicence={highlightedLicence}
        onSelectLicence={onSelectLicence}
      />

      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Button
          startIcon={<ChevronLeftIcon />}
          disabled={!prev}
          onClick={() => prev && onSelectPool(prev.id)}
          size="small"
          color="inherit"
          sx={ctaTextSx(theme)}
        >
          {prev ? prev.label : "Précédente"}
        </Button>
        <Button
          endIcon={<ChevronRightIcon />}
          disabled={!next}
          onClick={() => next && onSelectPool(next.id)}
          size="small"
          color="inherit"
          sx={ctaTextSx(theme)}
        >
          {next ? next.label : "Suivante"}
        </Button>
      </Stack>
    </Stack>
  );
}
